import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { wa, pageEventTypes } from 'apps/analytics';

export default class SearchSuggestions extends PureComponent {
  static propTypes = {
    clearAndCollapse: PropTypes.func.isRequired,
    isMoreProminentSearchEnabled: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    multiSearchLinkText: PropTypes.string,
    onSearchSuggestionClick: PropTypes.func.isRequired,
    onSearchSuggestionMouseOver: PropTypes.func.isRequired,
    showSimpleMultiSearch: PropTypes.bool.isRequired,
    searchSuggestionsTerm: PropTypes.string.isRequired,
    searchSuggestionsList: PropTypes.array.isRequired,
    selectedSearchSuggestion: PropTypes.string,
  };

  static defaultProps = {
    selectedSearchSuggestion: '',
    multiSearchLinkText: 'Search for multiple items',
  };

  getSearchSuggestionListElement = (rawSuggestion) => {
    let liText = rawSuggestion; // it's always lowercased
    const isSelected = rawSuggestion === this.props.selectedSearchSuggestion;
    const searchTerm = this.props.searchSuggestionsTerm;
    const searchTermLen = searchTerm.length;
    if (searchTermLen) {
      const searchTermSubstringStart = rawSuggestion.indexOf(searchTerm);
      if (searchTermSubstringStart >= 0) {
        liText = (
          <span>
            {rawSuggestion.slice(0, searchTermSubstringStart)}
            <b>{rawSuggestion.substr(searchTermSubstringStart, searchTermLen)}</b>
            {rawSuggestion.slice(searchTermSubstringStart + searchTermLen)}
          </span>
        );
      }
    }

    return (
      // keyboard events (accessibility) are covered by parent component (headerSearch)
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      <li
        key={rawSuggestion}
        className={
          classNames('hd-searchSuggestions__listElement', { 'hd-searchSuggestions__listElement--selected': isSelected })
        }
        onMouseOver={() => this.handleSuggestionOnMouseOver(rawSuggestion)}
        onMouseDown={() => this.handleSuggestionOnMouseDown(rawSuggestion)}
        tabIndex="-1"
        aria-selected={isSelected}
        role="option"
      >
        {liText}
      </li>
    );
  };

  handleSuggestionOnMouseOver(suggestion) {
    this.props.onSearchSuggestionMouseOver(suggestion);
  }

  handleSuggestionOnMouseDown(chosenSuggestion) {
    this.reportSearchSuggestionSelected(chosenSuggestion);
    this.props.onSearchSuggestionClick(chosenSuggestion);
    this.props.clearAndCollapse();
  }

  reportSearchSuggestionSelected = (chosenSuggestion) => {
    const { searchSuggestionsTerm, searchSuggestionsList } = this.props;
    if (!searchSuggestionsTerm) {
      const chosenSuggestionIndex = searchSuggestionsList.indexOf(chosenSuggestion);
      wa.triggerPageEvent(pageEventTypes.RELATED_SEARCH_SUGGESTION_SELECTED,
        {
          SEARCH_TERM: searchSuggestionsList[chosenSuggestionIndex],
          CHOSEN_SUGGESTION_POSITION: chosenSuggestionIndex,
        },
      );
    }
  };

  render() {
    const {
      isLoggedIn,
      isMoreProminentSearchEnabled,
      multiSearchLinkText,
      showSimpleMultiSearch,
      searchSuggestionsList,
    } = this.props;

    if (!showSimpleMultiSearch && !searchSuggestionsList.length) {
      return null;
    }

    return (
      <div
        id="hd-searchSuggestions"
        className={classNames(
          'hd-searchSuggestions',
          {
            'hd-searchSuggestionsProminent': isMoreProminentSearchEnabled,
            'hd-searchSuggestionsProminent--loggedIn': isLoggedIn && isMoreProminentSearchEnabled,
          }
        )}
      >
        <div className="hd-searchSuggestions__container">
          <ul className="hd-searchSuggestions__list" role="listbox">
            {searchSuggestionsList.map(this.getSearchSuggestionListElement)}
          </ul>
          {
            showSimpleMultiSearch && (
              <p className="hd-searchSuggestions__multiSearch">
                <a
                  href="/webshop/getMultiSearchProducts.do"
                  className="hd-searchSuggestions__multiSearchLink"
                >
                  {multiSearchLinkText}
                </a>
              </p>
            )}
        </div>
      </div>
    );
  }
}
